import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker, Divider, List, Card, Space, Typography } from 'antd';
import moment from 'moment';
import axios from 'axios';

import { requestError } from '../../controllers/functions';
import { useEffect, useState } from 'react';
import { useCallback } from 'react';

const { Text } = Typography;
const { Option } = Select;

const QuotationModal = ({ type, show, setOpenModal, schoolId, getInvoices, extractTokenFromUrl }) => {

  const [form] = Form.useForm();
  const [quotationItemForm] = Form.useForm();
  const [quotationForm] = Form.useForm();
  const [ currences, setCurrencies ] = useState([]);
  const [ items, setItems ] = useState([]);
  const [ loading, setLoading ] = useState({});

  const getCurrences = useCallback(() => {
    setLoading( prev => ({ ...prev, loadingCurrencies : true }) );
    axios.get( process.env.REACT_APP_API_URI+"/school/fees/currencies", {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        setCurrencies(done.data);
      }).catch( error => {
          requestError({error});
      }).finally( () => {
          setLoading( prev => ({ ...prev, loadingCurrencies : false }) );
      })
  }, [extractTokenFromUrl]);

  useEffect( () => {
    if(show) {
      getCurrences();
      quotationForm.resetFields();
      form.resetFields();
      setItems([]);
    }
  }, [form, getCurrences, quotationForm, show])

  const saveQuotation = () => {
    if(items.length === 0) {
        message.error("Please add at least one item to the quotation.");
        return;
    }

    const allSameCurrency = items.length > 0 && items.every(item => item.currencyId === items[0].currencyId);
    if(!allSameCurrency) {
        message.error("All items must have the same currency.");
        return;
    }

    setLoading( prev => ({ ...prev, savingQuotation : true }) );
    const url = process.env.REACT_APP_API_URI+"/schools/subscriptions/invoices";
    axios.post( url ,{ ...quotationForm.getFieldsValue(), date : moment(quotationForm.getFieldValue('date')).format('YYYY-MM-DD'), type, items, schoolId }, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        message.success(done.data.res);
        getInvoices();
        quotationForm.resetFields();
        setItems([]);
        setOpenModal(false);
    }).catch( error => {
        requestError({error});
    }).finally( done =>{
      setLoading( prev => ({ ...prev, savingQuotation : false }) );
    })
  }


  return (
    <>
    
      <Modal 
      title={type === 'quotation' ? `Quotation` : 'Invoice' }
      open={show} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      footer={[
        <Button variant="dashed" color='blue' htmlType='submit' form='subscription-quotation-form' loading={loading?.savingQuotation} >
            Add {type === 'quotation' ? `Quotation` : 'Invoice' }
        </Button>,  
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}} danger>
            Close
        </Button>
      ]}
      >
        <Divider/>
        <Form
        layout="vertical"
        className="row-col"
        onFinish={ saveQuotation }
        id="subscription-quotation-form" 
        form={quotationForm}
        >
            <Row gutter={[10,1]}>
                <Col span={12}>
                    <Form.Item
                    name="date"
                    
                    rules={[
                        { required: true, message: "Enter Quotation date!" },
                    ]}
                    >
                        <DatePicker format={'DD/MM/YYYY'} style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                    style={{ marginRight: 5, textAlign : "center" }}
                    >
                        Total Quotation: <span style={{ fontWeight: "bold" }}>{`USD ${items.reduce((acc, { unitPrice, quantity }) => acc + unitPrice * quantity, 0)}`}</span>
                    </Form.Item>
                </Col>
            </Row>
        </Form>

        <QuotationItems currences={currences} items={items} />

        <Divider style={{ marginTop : 2 }}/>

        <Form
        layout="vertical"
        className="row-col"
        onFinish={ (v) => {
            setItems([...items, v]);
            quotationItemForm.resetFields();
        } }
        id="subscription-quotation-items-form" 
        form={quotationItemForm}
        >
            <Row  gutter={[10,1]}>

            <Col span={24}>
                <Form.Item
                name="description"
                
                rules={[
                    { required: true, message: "Please  description!" },
                ]}
                >
                <Input placeholder='Please  description!' />
                </Form.Item>
            </Col>

            <Col span={8}>
                <Form.Item
                name="quantity"
                
                rules={[
                    { required: true, message: "Please enter quantity!" },
                ]}
                >
                <Input type='number' placeholder='Quantity!' />
                </Form.Item>
            </Col>

            <Col span={8}>
                <Form.Item
                name="currencyId"
                
                rules={[
                    { required: true, message: "Select Month!" },
                ]}
                >
                <Select
                    showSearch
                    placeholder="Currency"
                    optionFilterProp="children"
                    style={{ height: 29, width: "100%" }}
                >
                    {currences.map((currency) => (
                        <Option value={currency?.id} key={currency?.id}>
                            {currency?.name}
                        </Option>
                    ))}
                </Select>
                </Form.Item>
            </Col>

            <Col span={8}>
                <Form.Item
                name="unitPrice"
                
                rules={[
                    { required: true, message: "Please input Unit Price!" },
                ]}
                >
                <Input type='number' step={0.01} placeholder="Unit Price!" />
                </Form.Item>
            </Col>

            <Col span={24}>
                <Form.Item>
                    <Button variant="dashed" color='green' htmlType='submit' form='subscription-quotation-items-form' block>
                        Add Item to {type === 'quotation' ? `Quotation` : 'Invoice' }
                    </Button>
                </Form.Item>
            </Col>

            </Row>
        </Form>

      </Modal>
    </>
  );
};

export default QuotationModal;



const QuotationItems = ({ currences, items }) => {

    const [currencyMap, setCurrencyMap] = useState({});

    useEffect(() => {
        const map = {};
        currences.forEach(currency => {
            map[currency.id] = currency.name;
        });
        setCurrencyMap(map);
    }, [currences]);

    return (
        <List
        dataSource={items}
        renderItem={(item, index) => (
            <List.Item key={index}>
            <Card
                size="small"
                style={{ width: "100%" }}
                bodyStyle={{ padding: "12px 16px" }}
            >
                <Space direction="vertical" size={2} style={{ width: "100%" }}>
                <Text strong>{item.description} ({item.quantity} Units @ {currencyMap[item.currencyId]} {item.unitPrice}/Unit)</Text>
                <Text>
                    <span>Amount: {currencyMap[item.currencyId]} <Text strong>{item.unitPrice*item.quantity}</Text></span>
                </Text>
                </Space>
            </Card>
            </List.Item>

        )}
        />
    );
};
